<template>
    <div style="height: 100%;" v-loading="loading">
        <div class="header" style="display: flex; align-items: center; justify-content: space-between; height: 60px; border-bottom: solid 1px lightgray; background-color: #4570c7; color: white;">
            <router-link to="/projects">
                <div style="display: flex; align-items: center; margin-left: 16px; color: white; width: 44px; height: 100%; text-align: center;">
                    <i class="fas fa-arrow-left"></i>
                </div>
            </router-link>
            <div style="font-size: 17px; margin: 8px 16px;">
                {{project.attributes.name}}
            </div>
            <div style="margin: 8px 0; display: flex; align-items: center;">
                <div style="cursor: pointer; display: flex; align-items: center; color: white; width: 32px; height: 100%; text-align: center;" @click="isEditMode = true;">
                    <i v-if="!isEditMode" class="far fa-edit"></i>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
            <el-card class="box-card" style="width: 100%; max-width: 700px;">
                <div style="display: flex; flex-direction: column; margin: 32px 0;" v-if="$route.params.projectId != 'new'">
                    <div style="font-weight: 700;">
                        Photos & Videos
                    </div>
                    <div v-if="!isEditMode" style="margin: 16px 0; width: 100%;">
                        <el-upload :on-success="handleUploaded" :data="form" :headers="{ 'Authorization': 'JWT ' + auth.getToken()}" accept="image/*;video/*;capture=camcorder" :action="`https://api.projectsmaps.com/upload`" :file-list="fileList" multiple>
                            <el-button type="primary" style="width: 100%;">Upload</el-button>
                        </el-upload>
                    </div>
                    <div style="margin: 8px 0; display: flex; flex-wrap: wrap;">
                        <div v-if="isEditMode">
                            <div class="image" v-for="image, imageIndex in project_assets.map(asset => asset.attributes.public_url)" @click="handleDeleteAsset(imageIndex)" :style="{ backgroundImage: 'url(' + image + ')', width: '60px', height: '60px', position: 'relative' }">
                                <div style="position: absolute; left: 0; top: 0; background: black; opacity: 0.5; width: 100%; height: 100%; cursor: pointer;">
                                </div>
                                <div style="position: absolute; top: 22px; left: 23px;">
                                    <i class="far fa-trash-alt" style="color: white;"></i>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <vue-gallery :images="project_assets.map(asset => asset.attributes.public_url)" :index="index" @close="index = null"></vue-gallery>
                            <div class="image" v-for="image, imageIndex in project_assets.map(asset => asset.attributes.public_url)" @click="index = imageIndex" :style="{ backgroundImage: 'url(' + image + ')', width: '60px', height: '60px' }"></div>
                        </div>
                    </div>
                </div>
                <div style="margin: 0 0 8px 0; display: flex; align-items: center;" v-if="isEditMode">
                    <div style="margin: 8px 0; width: 82px; font-weight: 700;">
                        <label>Title</label>
                    </div>
                    <div v-if="!isEditMode">{{project.attributes.name}}</div>
                    <el-input v-else placeholder="Kitchen in Tarzana" v-model="project.attributes.name"></el-input>
                </div>
                <div style="max-width: 700px;">
                    <div style="margin: 0 0 8px 0; display: flex; align-items: center;">
                        <div style="margin: 8px 0; width: 82px; font-weight: 700;">
                            <label>Address</label>
                        </div>
                        <div v-if="isEditMode || !project.attributes.address" style="width: 100%;">
                            <vue-google-autocomplete id="address" classname="el-input__inner" placeholder="Start typing" v-on:inputChange="addressChanged" v-on:placechanged="getAddressData" country="us">
                            </vue-google-autocomplete>
                        </div>
                        <div v-else>
                            <div v-if="!isEditMode">{{project.attributes.address}}</div>
                        </div>
                    </div>
                </div>
                <div style="max-width: 700px;">
                    <div style="margin: 0 0 8px 0; display: flex; align-items: center;">
                        <div style="margin: 8px 0; width: 82px; font-weight: 700;">
                            <label>Budget</label>
                        </div>
                        <div v-if="isEditMode" style="width: 100%;">
                            <el-select v-model="project.attributes.budget" placeholder="Select">
                                <el-option v-for="item in budgetOptions" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                        <div v-else>
                            <div v-if="!isEditMode">{{project.attributes.budget}}</div>
                        </div>
                    </div>
                </div>
                <div v-if="project.attributes.created_at" style="max-width: 700px;">
                    <div style="margin: 0 0 8px 0; display: flex; align-items: center;">
                        <div style="margin: 8px 0; width: 82px; font-weight: 700;">
                            <label>Created at</label>
                        </div>
                        <div>
                            {{project.attributes.created_at | formatDate}}
                        </div>
                    </div>
                </div>
                <div v-if="isEditMode" style="margin-top: 16px; width: 100%;">
                    <div style="display: flex; align-items: center; flex-direction: row-reverse;">
                        <el-button type="primary" @click.native="handleSubmit" style="width: 100%;">{{getSubmitButtonTitle()}}</el-button>
                        <el-button v-if="$route.params.projectId != 'new'" type="default" style="margin-right: 8px; width: 100%;" @click.native="isEditMode = false;">Cancel</el-button>
                    </div>
                </div>
            </el-card>
            <div style="width: 100%; max-width: 700px; margin-top: 64px;">
                <div style="margin-top: 32px; width: 100%;">
                    <div v-if="isEditMode && $route.params.projectId != 'new'" style="display: flex; align-items: center; flex-direction: row-reverse;">
                        <el-button type="danger" @click.native="handleDeleteProject" style="width: 100%;">Delete</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import auth from '@/auth'
import VueGallery from 'vue-gallery';
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
    components: {
        VueGoogleAutocomplete,
        VueGallery
    },
    data() {
        return {
            loading: false,
            index: null,
            isEditMode: false,
            auth: auth,
            project: {
                attributes: {}
            },
            project_assets: [],
            input: '',
            form: {},
            fileList: [],
            budgetOptions: [
                '$250,000+',
                '$200,000 - $250,000',
                '$150,000 - $200,000',
                '$100,000 - $150,000',
                '$50,000 - $100,000',
                '$35,000 - $50,000',
                '$25,000 - $35,000',
                '$15,000 - $25,000',
                '$10,000 - $15,000',
                '$5,000 - $10,000',
                '$2,500 - $5,000',
                '$1,000 - $2,000',
                '<$1,000'
            ]
        }
    },
    mounted() {
        if (this.$route.params.projectId == 'new') {
            this.isEditMode = true;
            this.project = {
                attributes: {

                }
            }
        } else {
            this.$store.dispatch('projects/loadById', { id: this.$route.params.projectId }).then(() => {
                this.project = this.$store.getters['projects/byId']({ id: this.$route.params.projectId });
            });
            this.reloadAssets();
        }
    },
    methods: {
        handleDeleteProject() {
            this.$confirm('This will permanently delete the project. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.project.attributes.is_deleted = true;
                this.$store.dispatch('projects/update', this.project)
                    .then(() => {
                        this.$router.push('/projects');
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                    });
            }).catch(() => {

            });
        },
        handleDeleteAsset(index) {
            let asset = this.project_assets[index];
            this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                asset.attributes.is_deleted = true;
                this.$store.dispatch('project_assets/update', asset)
                    .then(() => {
                        this.reloadAssets();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                    });
            }).catch(() => {

            });
        },
        reloadAssets() {
            let filter = { filter: { project_id: this.$route.params.projectId, is_deleted: false } };
            this.$store.dispatch('project_assets/loadWhere', filter).then(() => {
                    this.project_assets = this.$store.getters['project_assets/where'](filter);
                })
                .catch(error => {
                    console.log(error)
                });
        },
        handleUploaded(response, file, fileList) {
            this.$store.dispatch('project_assets/create', {
                    attributes: {
                        public_url: response.public_url,
                        asset_type: 'IMAGE',
                        project_id: parseInt(this.$route.params.projectId)
                    }
                })
                .then(() => {
                    if (!this.project.attributes.thumb_url) {
                        this.project.attributes.thumb_url = response.public_url;
                        this.$store.dispatch('projects/update', this.project);
                    }
                    this.reloadAssets();
                });
        },
        handleSubmit() {
            if (this.$route.params.projectId == 'new') {
                this.loading = true;
                this.$store.dispatch('projects/create', this.project)
                    .then(() => {
                        const project = this.$store.getters['projects/lastCreated'];
                        this.project = project;
                        this.$router.push(`/projects/${project.id}`);
                        this.isEditMode = false;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.loading = true;
                this.$store.dispatch('projects/update', this.project)
                    .then(() => {
                        this.isEditMode = false;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        getSubmitButtonTitle() {
            return this.$route.params.projectId == 'new' ? 'Create' : 'Update';
        },
        getAddressData: function(addressData, placeResultData, id) {
            this.project.attributes.address = placeResultData.formatted_address;
        },
        addressChanged(v) {
            this.project.attributes.address = v.newVal;
        }
    }
}
</script>
<style>
.el-upload {
    width: 100%;
}

.image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
}
</style>
